/**
 * 台灣「日期固定」的國定假日快速匯入清單。
 *
 * 刻意只收錄日期年年固定者：補班、彈性放假、農曆節日（春節、端午、中秋等）
 * 逐年由政府行政院人事行政總處公告變動，不屬於「日期固定」，也不會寫死在此處
 * —— 這類假日請由使用者依當年公告，用「新增例外」自行輸入日期區間。
 */
import type { CalendarException } from '@bigint-project/core';

export interface FixedHolidayTemplate {
  readonly id: string;
  readonly name: string;
  /** 月（1–12）。 */
  readonly month: number;
  /** 日。 */
  readonly day: number;
}

export const TAIWAN_FIXED_HOLIDAYS: readonly FixedHolidayTemplate[] = [
  { id: 'tw-new-year', name: '元旦', month: 1, day: 1 },
  { id: 'tw-peace-memorial', name: '和平紀念日', month: 2, day: 28 },
  { id: 'tw-childrens-day', name: '兒童節', month: 4, day: 4 },
  { id: 'tw-labor-day', name: '勞動節', month: 5, day: 1 },
  { id: 'tw-national-day', name: '國慶日', month: 10, day: 10 },
];

/** 以「今年」為起始年份，建立一條每年重複的例外規則（Yearly, interval 1，不設 until）。 */
export function fixedHolidayToException(
  template: FixedHolidayTemplate,
  referenceYear: number,
): CalendarException {
  const mm = String(template.month).padStart(2, '0');
  const dd = String(template.day).padStart(2, '0');
  const iso = `${referenceYear}-${mm}-${dd}`;
  return {
    id: `${template.id}-${referenceYear}-${Math.random().toString(36).slice(2, 8)}`,
    name: template.name,
    from: iso as CalendarException['from'],
    to: iso as CalendarException['to'],
    working: false,
    workingTimes: [],
    recurrence: { kind: 'Yearly', interval: 1 },
  };
}
